import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Header, Segment } from 'semantic-ui-react';
import HeaderSmall from './HeaderSmall';
import FooterBlock from './FooterBlock';
import ContactForm from './ContactForm';

const Contact = () => (
  <div>
    <Helmet defer={false}>
      <title>TribeVibe - Contact Us</title>
    </Helmet>
    <HeaderSmall />
    <Segment style={{ padding: '8em 0em' }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={8}>
            <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
              Contact Us
            </Header>
            <p style={{ fontSize: '1.2em' }}>
              If you'd like to get in contact for any reason, please
              feel welcome to reach out using the form below.
            </p>
            <ContactForm />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <FooterBlock />
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js